import React from 'react'
import { api } from '../lib/api.js'

function Badge({ status }) {
  const s = String(status || '').toLowerCase()
  const cls =
    s.includes('done') ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200' :
    s.includes('progress') ? 'border-sky-500/30 bg-sky-500/10 text-sky-200' :
    'border-white/15 bg-white/5 text-white/70'
  return <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs ${cls}`}>{status || 'Planned'}</span>
}

export default function Roadmap() {
  const [items, setItems] = React.useState([])
  const [err, setErr] = React.useState('')

  React.useEffect(() => {
    let live = true
    api('/api/roadmap')
      .then((d) => { if (live) setItems(Array.isArray(d.items) ? d.items : []) })
      .catch((e) => { if (live) setErr(e.message || 'Unable to load roadmap.') })
    return () => { live = false }
  }, [])

  return (
    <div className="mx-auto max-w-6xl px-4 py-12">
      <div className="text-xs tracking-[0.32em] text-white/60">ROADMAP</div>
      <h1 className="mt-2 text-3xl md:text-5xl font-semibold">Public Roadmap</h1>
      <p className="mt-4 text-white/60 max-w-3xl">
        What we are building, what is next, and what is shipped.
      </p>

      {err ? (
        <div className="mt-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-200">{err}</div>
      ) : null}

      <div className="mt-8 grid gap-4">
        {items.map((it, idx) => (
          <div key={it.id || idx} className="rounded-2xl border border-white/10 bg-panel/60 glow p-6">
            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
              <div className="text-lg font-semibold">{it.title || 'Untitled milestone'}</div>
              <div className="flex items-center gap-3">
                {it.eta ? <div className="text-xs text-white/50">ETA: <span className="text-white/70">{it.eta}</span></div> : null}
                <Badge status={it.status} />
              </div>
            </div>
            {it.details ? <div className="mt-3 text-sm text-white/60">{it.details}</div> : null}
          </div>
        ))}
        {!items.length ? (
          <div className="rounded-2xl border border-white/10 bg-black/20 p-6 text-white/60">No roadmap items yet.</div>
        ) : null}
      </div>
    </div>
  )
}
